global.I18n = I18n;

export function setDefaultLocale() {
  var defaultLocale = $('html').data('default-lang');
  var currentLocale = $('html').attr('lang');

  I18n.defaultLocale = defaultLocale;
  I18n.locale = currentLocale;
}
